import { getMarketoFormInterface } from "../process";
import { validateForm } from "../setup";
import {
  showFormProcessing,
  endFormProcessing,
  showSubmissionText,
  handleUncontrolledSubmitButton,
} from "./util";
import { marketoFormSetup } from "./marketoSetup";
import { MarketoFormMap } from "./marketoMap";
import { postSubmitPipe } from "../postSubmit";
import { formSubmissionError, selectedLocationInForm } from "../gtm";

//  return false based on API
const mkFormOnSuccess = ($form, $controlledSubmitButton) => (
  mkFormValues,
  requestedURL
) => {
  showSubmissionText($controlledSubmitButton);
  handleUncontrolledSubmitButton(showSubmissionText);
  endFormProcessing($controlledSubmitButton);
  handleUncontrolledSubmitButton(endFormProcessing);
  setTimeout(() => {
    postSubmitPipe($form, mkFormValues, requestedURL);
  }, 300);
  return false;
};

//  This is Marketo Validation, not expecting the validation to fail
//  we rely on JS validation -> mk validation doesn't give you which field failed
const mkFormOnValidate = (isValid) => {
  if (!isValid) {
    formSubmissionError();
    throw Error("Marketo From Not Validated.");
  }
};

export const formMarketoSubmitPipe = ($form) => async (e) => {
  e.preventDefault();
  const $inputEls = $form.find("input, select, textarea");
  const $controlledSubmitButton = $form.find("button[type=submit]");

  showFormProcessing($controlledSubmitButton);
  handleUncontrolledSubmitButton(showFormProcessing);

  //  1. JS validation
  const { isValidated, values } = validateForm($inputEls);

  if (!isValidated) {
    endFormProcessing($controlledSubmitButton);
    handleUncontrolledSubmitButton(endFormProcessing);
    return;
  }

  const marketoFormName = $form.attr("name");
  let marketoFormId = MarketoFormMap[marketoFormName];
  let mkForm;
  if (marketoFormId) {
    mkForm = await marketoFormSetup(marketoFormId);
  } else {
    marketoFormId = $form.attr("id");
    mkForm = await marketoFormSetup(marketoFormId.split("_")[0]);
  }

  mkForm.onSuccess(mkFormOnSuccess($form, $controlledSubmitButton));
  mkForm.onValidate(mkFormOnValidate($controlledSubmitButton));

  //  2. process form data to Marketo -> use hidden fields because that's the Marketo tooling we set up
  //  if it's the catch all form id, then we will look one level deeper

  const mkFormValues = getMarketoFormInterface(
    marketoFormId
  ).composeMkFormValues(values);

  mkForm.addHiddenFields(mkFormValues);

  if (mkFormValues.Select_Location__c || mkFormValues.referrerCity) {
    selectedLocationInForm(
      mkFormValues.Select_Location__c || mkFormValues.referrerCity
    );
  }

  //  3. submit -> not expecting mkForm.submit to fail
  //  failed mkform validation does not result in error
  new Promise((resolve, reject) => {
    try {
      resolve(mkForm.submit());
    } catch (e) {
      formSubmissionError();
      reject(e);
    }
  });
};
